import { NgModule, inject } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { TokenInterceptor } from "@app/interceptors/token.interceptor";
import { LoggingService } from "./services/logging.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslationService } from "./services/translation.service";
import { LoginModalComponent } from "./components/login-modal/login.modal";
import { NavigationComponent } from "./components/navigation/navigation.component";
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslationHandler } from "./translations/translation.handler";
import { TextFragmentLoader } from "./translations/text-fragment.loader";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MaintenanceComponent } from "./components/maintenance/maintenance.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { SharedModule } from "@shared/shared.module";
import { ReponseToastInterceptor } from "./interceptors/response-toast.interceptor";
import { AuthGuard } from "./guards/auth.guard";
import { CloudErpSsoComponent } from "./components/cloud-erp-sso.component";
import { TelenetIconModule } from "@shared/telenet-icons";
import { CustomToastComponent } from "./components/custom-toast/custom-toast.component";
import { ModalLoginComponent } from "./components/modal-login/modal-login.component";

@NgModule({
   declarations: [CustomToastComponent],
   exports: [LoginModalComponent, NavigationComponent],
   imports: [
      CommonModule,
      FormsModule,
      RouterModule,
      // no defaultLanguage: it would load before the app settings are known; AppComponent calls translate.use()
      TranslateModule.forRoot({
         loader: { provide: TranslateLoader, useClass: TextFragmentLoader },
         missingTranslationHandler: {
            provide: MissingTranslationHandler,
            useClass: TranslationHandler,
            deps: [TranslationService]
         },
         useDefaultLang: false
      }),
      NgbModule,
      SharedModule,
      TelenetIconModule,
      LoginModalComponent,
      NavigationComponent,
      MaintenanceComponent,
      ModalLoginComponent,
      NotFoundComponent,
      CloudErpSsoComponent
   ],
   providers: [
      // Replaces the deprecated HttpClientModule. withInterceptorsFromDi() keeps the
      // HTTP_INTERCEPTORS class interceptors below wired up.
      provideHttpClient(withInterceptorsFromDi()),
      {
         provide: HTTP_INTERCEPTORS,
         useClass: TokenInterceptor,
         multi: true
      },
      {
         provide: HTTP_INTERCEPTORS,
         useClass: ReponseToastInterceptor,
         multi: true
      },
      CookieService,
      AuthGuard
   ]
})
export class CoreModule {
   private log = inject(LoggingService);

   constructor() {
      this.log.info("Loading core module");
   }
}
